import styled from 'styled-components';
import {Divider} from 'antd';
import {iconColor, typographyStyles} from '../../../../utils/styles';

const StyledAccountBalanceDropdownOverlay = styled.div`
  background: ${props => props.theme.colors.neutral_1};
  border: 1px solid ${props => props.theme.colors.neutral_4};
  border-radius: ${props => props.theme.border_radius.standard};
  box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12);
  min-width: 280px;
  padding: 4px 0;
`;

const StyledAccountBalanceDropdownAccountItem = styled.div`
  ${typographyStyles.body.regular};
  color: ${props => props.theme.colors.neutral_10};
  padding: 8px 16px;
  gap: 8px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StyledAccountBalanceDropdownOptionLabel = styled.div`
  ${typographyStyles.body.medium};
  color: ${props => props.theme.colors.neutral_10};
`;

const StyledAccountBalanceDropdownOptionAmount = styled.span`
  ${typographyStyles.body.regular};
  color: ${props => props.theme.colors.neutral_10};
`;

const StyledAccountBalanceDropdownFooter = styled.div`
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

const StyledAccountBalanceDropdownSyncStatus = styled.span`
  ${typographyStyles.footnote.description};
  color: ${props => props.theme.colors.neutral_6};
  display: flex;
  align-items: center;
  gap: 4px;
`;

const StyledAccountBalanceDropdownConnectBankLink = styled.a`
  ${typographyStyles.body.regular};
  color: ${props => props.theme.colors.primary_6};
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    color: ${props => props.theme.colors.primary_7};
  }
`;

const StyledAccountBalanceDropdownDivider = styled(Divider)`
  margin: 4px 0;
`;

const StyledAccountBalanceDropdownAccountsList = styled.div`
  max-height: 250px;
  overflow-y: auto;
`;

const StyledAccountBalanceDropdownError = styled.div`
  ${typographyStyles.footnote.description};
  color: ${props => props.theme.colors.error_6 ?? props.theme.colors.error ?? '#ff4d4f'};
  padding: 4px 0 0;
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
`;

const StyledAccountBalanceDropdown = styled.div`
  border: 1px solid ${props => props.theme.colors.neutral_5};
  border-radius: 8px;
  padding: 8px 8px 8px 12px;
  display: flex;
  align-items: center;
  transition: .2s ease-in;

  svg {
    & * {
      transition: .2s ease-in;
    }
  }

  &:hover {
    border-color: ${props => props.theme.colors.primary_6};
    cursor: pointer;

    .account-balance-dropdown-icon > svg {
      ${iconColor(props => props.theme.colors.primary_6, true)}
    }
  }
`;

export {
  StyledAccountBalanceDropdownOverlay,
  StyledAccountBalanceDropdownAccountsList,
  StyledAccountBalanceDropdownAccountItem,
  StyledAccountBalanceDropdownOptionLabel,
  StyledAccountBalanceDropdownOptionAmount,
  StyledAccountBalanceDropdownFooter,
  StyledAccountBalanceDropdownSyncStatus,
  StyledAccountBalanceDropdownConnectBankLink,
  StyledAccountBalanceDropdownDivider,
  StyledAccountBalanceDropdownError,
  StyledAccountBalanceDropdown,
};
